"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_MAP = void 0;
/**
 * 内置颜色表
 * @const
 */
exports.COLOR_MAP = {
    Black: '#000000',
    Blue: '#0000FF',
    Cyan: '#00FFFF',
    Green: '#008000',
    Magenta: '#FF00FF',
    Red: '#FF0000',
    White: '#FFFFFF',
    Yellow: '#FFFF00',
    黑色: '#000000',
    蓝色: '#0000FF',
    蓝绿色: '#00FFFF',
    绿色: '#008000',
    洋红色: '#FF00FF',
    红色: '#FF0000',
    白色: '#FFFFFF',
    黄色: '#FFFF00',
    颜色0: '#00000000',
    颜色1: '#00FFFFFF',
    颜色2: '#00FF0000',
    颜色3: '#0000FF00',
    颜色4: '#000000FF',
    颜色5: '#00FFFF00',
    颜色6: '#00FF00FF',
    颜色7: '#0000FFFF',
    颜色8: '#00000000',
    颜色9: '#00FFFFFF',
    颜色10: '#00FF0000',
    颜色11: '#0000FF00',
    颜色12: '#000000FF',
    颜色13: '#00FFFF00',
    颜色14: '#00FF00FF',
    颜色15: '#0000FFFF',
    颜色16: '#00800000',
    颜色17: '#00008000',
    颜色18: '#00000080',
    颜色19: '#00808000',
    颜色20: '#00800080',
    颜色21: '#00008080',
    颜色22: '#00C0C0C0',
    颜色23: '#00808080',
    颜色24: '#009999FF',
    颜色25: '#00993366',
    颜色26: '#00FFFFCC',
    颜色27: '#00CCFFFF',
    颜色28: '#00660066',
    颜色29: '#00FF8080',
    颜色30: '#000066CC',
    颜色31: '#00CCCCFF',
    颜色32: '#00000080',
    颜色33: '#00FF00FF',
    颜色34: '#00FFFF00',
    颜色35: '#0000FFFF',
    颜色36: '#00800080',
    颜色37: '#00800000',
    颜色38: '#00008080',
    颜色39: '#000000FF',
    颜色40: '#0000CCFF',
    颜色41: '#00CCFFFF',
    颜色42: '#00CCFFCC',
    颜色43: '#00FFFF99',
    颜色44: '#0099CCFF',
    颜色45: '#00FF99CC',
    颜色46: '#00CC99FF',
    颜色47: '#00FFCC99',
    颜色48: '#003366FF',
    颜色49: '#0033CCCC',
    颜色50: '#0099CC00',
    颜色51: '#00FFCC00',
    颜色52: '#00FF9900',
    颜色53: '#00FF6600',
    颜色54: '#00666699',
    颜色55: '#00969696',
    颜色56: '#00003366',
    颜色57: '#00339966',
    颜色58: '#00003300',
    颜色59: '#00333300',
    颜色60: '#00993300',
    颜色61: '#00993366',
    颜色62: '#00333399',
    颜色63: '#00333333',
    Color0: '#00000000',
    Color1: '#00FFFFFF',
    Color2: '#00FF0000',
    Color3: '#0000FF00',
    Color4: '#000000FF',
    Color5: '#00FFFF00',
    Color6: '#00FF00FF',
    Color7: '#0000FFFF',
    Color8: '#00000000',
    Color9: '#00FFFFFF',
    Color10: '#00FF0000',
    Color11: '#0000FF00',
    Color12: '#000000FF',
    Color13: '#00FFFF00',
    Color14: '#00FF00FF',
    Color15: '#0000FFFF',
    Color16: '#00800000',
    Color17: '#00008000',
    Color18: '#00000080',
    Color19: '#00808000',
    Color20: '#00800080',
    Color21: '#00008080',
    Color22: '#00C0C0C0',
    Color23: '#00808080',
    Color24: '#009999FF',
    Color25: '#00993366',
    Color26: '#00FFFFCC',
    Color27: '#00CCFFFF',
    Color28: '#00660066',
    Color29: '#00FF8080',
    Color30: '#000066CC',
    Color31: '#00CCCCFF',
    Color32: '#00000080',
    Color33: '#00FF00FF',
    Color34: '#00FFFF00',
    Color35: '#0000FFFF',
    Color36: '#00800080',
    Color37: '#00800000',
    Color38: '#00008080',
    Color39: '#000000FF',
    Color40: '#0000CCFF',
    Color41: '#00CCFFFF',
    Color42: '#00CCFFCC',
    Color43: '#00FFFF99',
    Color44: '#0099CCFF',
    Color45: '#00FF99CC',
    Color46: '#00CC99FF',
    Color47: '#00FFCC99',
    Color48: '#003366FF',
    Color49: '#0033CCCC',
    Color50: '#0099CC00',
    Color51: '#00FFCC00',
    Color52: '#00FF9900',
    Color53: '#00FF6600',
    Color54: '#00666699',
    Color55: '#00969696',
    Color56: '#00003366',
    Color57: '#00339966',
    Color58: '#00003300',
    Color59: '#00333300',
    Color60: '#00993300',
    Color61: '#00993366',
    Color62: '#00333399',
    Color63: '#00333333',
};
//# sourceMappingURL=color-const.js.map